import { AbstractModel } from '@patsnap/tahiti-core';
import { FtoReportCurrentMatchedPatentModel } from '../current-matched-patent-model';
import type { CurrentMatchedPatentState } from '../../types';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

function createInitialMatchedPatentState(): CurrentMatchedPatentState {
    return {
        ranking: [],
        manualAdded: [],
        extraAdded: [],
    };
}

@injectable()
export class FtoReportCurrentMatchedPatentModelImpl extends AbstractModel<CurrentMatchedPatentState> implements FtoReportCurrentMatchedPatentModel {
    protected _modelData: CurrentMatchedPatentState = createInitialMatchedPatentState();

    dispose(): void {
        this.update(() => createInitialMatchedPatentState());
    }
}
